import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslationService, SUPPORTED_LANGUAGES } from '../services/translation.service';

/**
 * Functional HTTP interceptor that adds the Accept-Language header
 * to every outgoing request, based on the current UI language.
 *
 * This ensures that backend APIs (and third-party services) receive
 * the user's language preference automatically.
 */
export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const translationService = inject(TranslationService);
  const lang = translationService.lang();

  // Build Accept-Language: current lang first, then others with decreasing quality
  const others = SUPPORTED_LANGUAGES.filter(l => l !== lang);
  const parts = [lang, ...others.map((l, i) => `${l};q=${(0.9 - i * 0.1).toFixed(1)}`)]
    .filter(p => !p.includes(';q=0.0') && !p.includes(';q=-'));
  const header = parts.join(',');

  const cloned = req.clone({
    setHeaders: { 'Accept-Language': header }
  });

  return next(cloned);
};
